import React, {useState} from "react";
import  NewSalesPage from "../../../../../entities/DashboardPage/AccountingModule/Customer/NewSalesOrder";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";

// import AuthService from "../../../api/AuthService";
// eslint-disable-next-line import/default
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";

const SalesList = () => {
  const [itemList, setItemList] = useState();

  const [loading, setLoading] = useState();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  const handleAddSales = async (salesOrder, expiryDate, Opportunity, description, product, subtotal, grandTotal, currency, exchangeRate, tax,  totalAmount) => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handlePurchase(salesOrder, expiryDate, Opportunity, description, product, subtotal, grandTotal, currency, exchangeRate, tax,  totalAmount);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message, "success");
        navigate("/dashboard/salesList")


      } else {
        
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
      // showAlert(error,"error");
    }
  };
  const getItem = async (text) => {
    setLoading(true);

    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        setLoading(false);
      } else {

        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
    }
  };

  return (
    
    <NewSalesPage itemList={itemList} loading={loading} handleAdd={handleAddSales} handleItemList={getItem}/>
  )


}

export default SalesList;
